'use strict';

/** Spacest partner — Coolliving (comisión 15% booking + descuento 10% usuario) */

const SPACEST_PROMO_CODE = 'COOLLIVING10';

/** Comisión afiliado Coolliving: 15% del precio del primer mes (si reserva). */
const SPACEST_AFFILIATE_COMMISSION_RATE = 0.15;

/** Escaparate Coolliving con catálogo Spacest paginado */
const SPACEST_SHOWCASE_PATH = '/coliving/spacest';

const SPACEST_PROMO_SAVINGS = {
  es: { amount: '10%', label: 'Ahorra un 10% en tu reserva en Spacest' },
};

const SPACEST_PROMO_MODAL = {
  es: {
    badge: 'Oferta exclusiva Spacest',
    title: 'Tu código de descuento',
    useCodeText: 'Usa este código al reservar en Spacest:',
    copyLabel: 'Copiar',
    copiedLabel: '¡Copiado!',
    footerText: 'Introduce el código al finalizar la reserva en Spacest para obtener un 10% de descuento. Te redirigiremos al alojamiento en una nueva pestaña.',
    ctaLabel: 'Continuar en Spacest',
    closeAriaLabel: 'Cerrar',
  },
};

function isSpacestPartnerSource(source) {
  return String(source || '').toLowerCase() === 'spacest';
}

function parseSpacestFirstMonthPriceEur(value) {
  const n = Number(value);
  if (!Number.isFinite(n) || n <= 0) return null;
  return Math.round(n);
}

function computeSpacestAffiliateCommissionEur(firstMonthPriceEur) {
  const base = parseSpacestFirstMonthPriceEur(firstMonthPriceEur);
  if (base == null) return null;
  return Math.round(base * SPACEST_AFFILIATE_COMMISSION_RATE * 100) / 100;
}

/** Texto + cifras para emails admin (jaime@coolliving.io). */
function getSpacestCommissionAdminDisplay(firstMonthPriceEur) {
  const price = parseSpacestFirstMonthPriceEur(firstMonthPriceEur);
  if (price == null) {
    return {
      firstMonthPriceEur: null,
      commissionEur: null,
      textLines: [
        'Precio 1er mes (listing): —',
        'Comisión estimada si reserva (15% 1er mes): —',
      ],
      subjectCommissionTag: '',
    };
  }
  const commission = computeSpacestAffiliateCommissionEur(price);
  return {
    firstMonthPriceEur: price,
    commissionEur: commission,
    textLines: [
      `Precio 1er mes (listing): ${price} €`,
      `Comisión estimada si reserva (15% 1er mes): ${commission} €`,
    ],
    subjectCommissionTag: commission != null ? ` · ~${commission}€` : '',
  };
}

function getSpacestPromoCopy() {
  const savings = SPACEST_PROMO_SAVINGS.es;
  const modal = SPACEST_PROMO_MODAL.es;

  return {
    code: SPACEST_PROMO_CODE,
    region: 'es',
    savingsAmount: savings.amount,
    savingsLabel: savings.label,
    modal,
  };
}

module.exports = {
  SPACEST_PROMO_CODE,
  SPACEST_AFFILIATE_COMMISSION_RATE,
  SPACEST_SHOWCASE_PATH,
  SPACEST_PROMO_SAVINGS,
  SPACEST_PROMO_MODAL,
  isSpacestPartnerSource,
  parseSpacestFirstMonthPriceEur,
  computeSpacestAffiliateCommissionEur,
  getSpacestCommissionAdminDisplay,
  getSpacestPromoCopy,
};
